import { GetterTree } from 'vuex'

import { RootState, MatchedState } from '@/types/store'

export const getters: GetterTree<MatchedState, RootState> = {
  matcheds(state): MatchedState['matcheds'] {
    return state.matcheds
  },
  total(state): MatchedState['total'] {
    return state.total
  },
  isMatchedsLoading(state): MatchedState['isMatchedsLoading'] {
    return state.isMatchedsLoading
  },
}
